module.exports = __webpack_public_path__ + "img/oil_painting_human2.ac5c3e99.jpg";